import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Card } from "../components/ui/card";
import { formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

const BG_URL =
  "https://static.prod-images.emergentagent.com/jobs/ed86f123-f4e4-45a6-b522-03e2c33e075e/images/a35b4bff3be844714c5ae5645635faff41526ec01e2f486f4dc25b3b55b27ad0.png";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("main@nivaragroup.ch");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (user && typeof user === "object") return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Willkommen zurück");
      navigate("/dashboard");
    } catch (err) {
      const msg = formatApiErrorDetail(err.response?.data?.detail) || err.message;
      setError(msg);
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-5" data-testid="login-page">
      <div
        className="hidden lg:block lg:col-span-3 bg-cover bg-center"
        style={{ backgroundImage: `url(${BG_URL})` }}
      >
        <div className="h-full flex flex-col justify-between p-12 bg-gradient-to-b from-white/0 via-white/0 to-white/60">
          <div>
            <div className="text-xs uppercase tracking-[0.2em] text-neutral-700">RS Service</div>
            <div className="mt-3 text-5xl font-semibold tracking-tight text-neutral-900">
              NIVARA
            </div>
            <div className="mt-1 text-neutral-700">7 Days Abrechnung & Controlling</div>
          </div>
          <div className="text-sm text-neutral-600 max-w-md">
            Präzise Monatsabrechnungen, Fahrerlöhne, Fahrzeugkosten und vollständige
            Abgleich-Kontrolle für Transport-Einsätze.
          </div>
        </div>
      </div>

      <div className="col-span-1 lg:col-span-2 flex items-center justify-center p-6 nivara-grid-bg">
        <Card className="w-full max-w-md p-8 border-neutral-200 shadow-sm" data-testid="login-card">
          <div className="mb-8">
            <div className="text-xs uppercase tracking-[0.2em] text-neutral-500">Admin Login</div>
            <h1 className="mt-2 text-2xl font-semibold tracking-tight">Anmelden</h1>
            <p className="mt-1 text-sm text-neutral-500">
              Nur autorisierte Administratoren.
            </p>
          </div>
          <form onSubmit={submit} className="space-y-5">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                data-testid="login-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Passwort</Label>
              <Input
                id="password"
                data-testid="login-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
            </div>
            {error && (
              <div className="text-sm text-red-600" data-testid="login-error">
                {error}
              </div>
            )}
            <Button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="w-full bg-[#0055FF] hover:bg-[#0040CC] text-white"
            >
              {loading ? "Anmelden…" : "Anmelden"}
            </Button>
          </form>
          <div className="mt-6 text-xs text-neutral-400">
            © {new Date().getFullYear()} RS Service · NIVARA
          </div>
        </Card>
      </div>
    </div>
  );
}
